import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


// toast.model.ts
export interface Toast {
    id: number;
    type: 'success' | 'error' | 'warning' | 'neutral' | 'notification';
    title: string;
    message: string;
    paused: boolean;
    remainingTime?: number;
}


@Injectable({
    providedIn: 'root'
})
export class ToastService {

    private toasts: Toast[] = [];
    private toastSubject = new BehaviorSubject<Toast[]>([]);
    public toast$ = this.toastSubject.asObservable();
    private idCounter = 0;
    private timeoutMap = new Map<number, any>();

    showToast(type: Toast['type'], title: string, message: string, duration: number = 3000) {
        const id = this.idCounter++;
        const toast: Toast = { id, type, title, message, paused: false, remainingTime: duration };

        const isDuplicate = this.toasts.some(
            t => t.message === toast.message && t.type === toast.type
        );

        if (!isDuplicate) {
            this.toasts.push(toast);
            this.toastSubject.next(this.toasts);
        }
        // this.toasts.push(toast);
        // this.toastSubject.next(this.toasts);

        const startTime = Date.now();
        const timeout = setTimeout(() => this.removeToast(toast.id), duration);

        this.timeoutMap.set(toast.id, {
            timeout,
            startTime,
            remaining: duration,
        });

    }

    // removeToast(id: number) {
    //     this.toasts = this.toasts.filter(t => t.id !== id);
    //     this.toastSubject.next(this.toasts);
    //     const timeoutObj = this.timeoutMap.get(id);
    //     if (timeoutObj) {
    //         clearTimeout(timeoutObj.timeout);
    //         this.timeoutMap.delete(id);
    //     }
    // }

    removeToast(id: number) {
        // Cancel the timeout to prevent double removal
        const timeoutObj = this.timeoutMap.get(id);
        if (timeoutObj) {
            clearTimeout(timeoutObj.timeout);
            this.timeoutMap.delete(id);
        }

        // Let the fade-out animation run (300ms) before removing from array
        setTimeout(() => {
            this.toasts = this.toasts.filter(t => t.id !== id);
            this.toastSubject.next(this.toasts);
        }, 300); // animation duration
    }


    public pauseToast(id: number) {
        const toast = this.toasts.find(t => t.id === id);
        const timeoutObj = this.timeoutMap.get(id);

        if (toast && timeoutObj) {
            toast.paused = true;

            // Calculate remaining time
            const elapsed = Date.now() - timeoutObj.startTime;
            const remaining = timeoutObj.remaining - elapsed;

            clearTimeout(timeoutObj.timeout);
            this.timeoutMap.set(id, {
                timeout: null,
                startTime: 0,
                remaining: remaining > 0 ? remaining : 0,
            });

            toast.remainingTime = remaining;
        }
    }

    public resumeToast(id: number) {
        const toast = this.toasts.find(t => t.id === id);
        const timeoutObj = this.timeoutMap.get(id);

        if (toast && timeoutObj && toast.paused) {
            toast.paused = false;

            const startTime = Date.now();
            const timeout = setTimeout(() => this.removeToast(id), timeoutObj.remaining);

            this.timeoutMap.set(id, {
                timeout,
                startTime,
                remaining: timeoutObj.remaining,
            });
        }
    }

}
